import { NeedsActivityDto } from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const NeedsActitivtiesTableColumns =
  (): ColumnConfiguration<NeedsActivityDto>[] => [
    {
      id: 'label',
      value: 'label',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Activity Label',
    },
    {
      id: 'overview',
      value: (props: NeedsActivityDto) => {
        const maxLength = 50;
        return props.overview.length > maxLength
          ? `${props.overview.substring(0, maxLength)}...`
          : props.overview;
      },
      isNumeric: false,
      shouldDisablePadding: false,
      title: 'Overview',
    },
    {
      id: 'defaultTimeFrameInMinutes',
      value: 'defaultTimeFrameInMinutes',
      isNumeric: true,
      shouldDisablePadding: false,
      title: 'Default Time Frame',
    },
    {
      id: 'iconName',
      value: (props: NeedsActivityDto) => {
        if (props.iconName) return props.iconName;
        return 'None';
      },
      isNumeric: false,
      shouldDisablePadding: false,
      title: 'Icon Name',
    },
    {
      id: 'key',
      value: 'key',
      isNumeric: false,
      shouldDisablePadding: false,
      title: 'Key',
    },
  ];
